export var OrganizationMemberRole;
(function (OrganizationMemberRole) {
    OrganizationMemberRole["MEMBER"] = "member";
    OrganizationMemberRole["VIEWER"] = "viewer";
    OrganizationMemberRole["INTERACTIVE_VIEWER"] = "interactive_viewer";
    OrganizationMemberRole["EDITOR"] = "editor";
    OrganizationMemberRole["DEVELOPER"] = "developer";
    OrganizationMemberRole["ADMIN"] = "admin";
})(OrganizationMemberRole || (OrganizationMemberRole = {}));
export const OrganizationMemberRoleLabels = {
    [OrganizationMemberRole.MEMBER]: 'Member',
    [OrganizationMemberRole.VIEWER]: 'Viewer',
    [OrganizationMemberRole.INTERACTIVE_VIEWER]: 'Interactive Viewer',
    [OrganizationMemberRole.EDITOR]: 'Editor',
    [OrganizationMemberRole.DEVELOPER]: 'Developer',
    [OrganizationMemberRole.ADMIN]: 'Admin',
};
export const isOrganizationMemberRole = (x) => Object.values(OrganizationMemberRole).includes(x);
export const isOrganizationMemberProfileWithGroups = (obj) => 'groups' in obj;
//# sourceMappingURL=organizationMemberProfile.js.map